import { IList } from "constants/common";

export interface IMoneyEarned extends IList {
  params: {
    email: any;
    page: number;
    limit: number;
  };
}

export enum Types {
  CHANGE_PARAMS = "[MONEY EARNED] CHANGE PARAMS",
  SET_DATA = "[MONEY EARNED] SET_DATA",
  LOAD_DATA = "[MONEY EARNED] LOAD_DATA",
  SET_LOADING = "[MONEY EARNED] SET_LOADING",
  CLEAR_STATE = "[MONEY EARNED] CLEAR_STATE",
}

export interface ClearStateAction {
  type: typeof Types.CLEAR_STATE;
}

export interface SetLoadingAction {
  type: typeof Types.SET_LOADING;
  payload: {
    loading: boolean;
  };
}

export interface ChangeParamsAction {
  type: typeof Types.CHANGE_PARAMS;
  payload: {
    params: any;
  };
}

export interface LoadDataAction {
  type: typeof Types.LOAD_DATA;
  payload: {
    params: any;
  };
}

export interface SetDataAction {
  type: typeof Types.SET_DATA;
  payload: { data: any[]; count: number };
}

export type Actions =
  | ClearStateAction
  | SetDataAction
  | LoadDataAction
  | ChangeParamsAction
  | SetLoadingAction;
